import { render, staticRenderFns } from "./BackgroundCheck.vue?vue&type=template&id=e2278504&"
import script from "./BackgroundCheck.vue?vue&type=script&lang=js&"
export * from "./BackgroundCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports